import { z } from 'zod';
import { ErrorCode } from '../../shared/error-codes';
import { EntitySuggestionSchema } from '../../entities/entity-suggestion';
import { AddSystemRequestSchema } from '../add-system/add-system.schema';
/** Point references at a System that already exists. */ const MigrateExisting = z.object({
    mode: z.literal('existing'),
    targetSystemId: z.string().min(1, ErrorCode.FIELD_REQUIRED)
});
/**
 * Promote the shadow to a brand-new System, then point references at it. The
 * new System is created via the same `AddSystemRequestSchema` the add-system
 * endpoint uses, so `systemOwner` is required (a System cannot exist without
 * one) and the service can forward the payload to `AddSystemService` untouched.
 */ const MigrateNew = z.object({
    mode: z.literal('new'),
    system: AddSystemRequestSchema
});
export const MigrateShadowSystemRequestSchema = z.discriminatedUnion('mode', [
    MigrateExisting,
    MigrateNew
]);
export const MigrateShadowSystemResponseSchema = z.object({
    data: EntitySuggestionSchema,
    rewrittenRecordingsCount: z.number().int().min(0),
    /** Set only when `mode === 'new'` — the id of the System just created. */ createdSystemId: z.string().optional()
});

//# sourceMappingURL=migrate-shadow-system.contract.js.map